import React, { FC, ReactNode } from 'react';
import styles from './entity_card_item_with_icon.module.scss';

type Props = {
  icon: ReactNode;
  subtitle: ReactNode;
  text: ReactNode;
};

export const EntityCardItemWithIcon: FC<Props> = ({ icon, subtitle, text }) => (
  <EntityCardIconBlock>
    {icon}
    <EntityCardIconSubtitle>{subtitle}</EntityCardIconSubtitle>
    {text}
  </EntityCardIconBlock>
);

const EntityCardIconBlock: FC = ({ children }) => (
  <div className={styles.iconBlock}>{children}</div>
);

const EntityCardIconSubtitle: FC = ({ children }) => (
  <div className={styles.iconSubtitle}>{children}</div>
);
